module.exports = __webpack_public_path__ + "files/c302734a64b5ba29dd1116309608ef98.png";